export default "__VITE_PUBLIC_ASSET__cc891685__"